module.exports = __webpack_public_path__ + "img/EN-ZH.c898545.png";